import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registerField, change } from 'redux-form';


class AttendingInput extends Component { // eslint-disable-line
  // componentDidMount() {
  //   const { input: { name, value }, onRegisterField, onChangeField } = this.props;
  //   onRegisterField(name, 'Field');
  //   onChangeField(name, value);
  // }

  render() {
    const { input, meta: { touched, error }, stepError } = this.props;
    const { onChange, value } = input;
    const isAttending = value === 'ATTENDING';
    const isDeclined = value === 'DECLINED';

    return (
      <div className={`form-group attending${touched && error ? ' has-error' : ''}`}>
        <div className="row">
          <div className="col-xs-6 col-sm-6 col-md-6">
            {window.zola.env !== 'production' ? (
              <div
                className={`btn ${isAttending ? ' btn-active' : ''}`}
                onClick={() => onChange('ATTENDING')}
              >
              Will<br className="mobile-only" /> Attend
            </div>
            ) : (
              <div
                className={`btn ${isAttending ? ' btn-active' : ''}`}
                onClick={() => onChange('ATTENDING')}
              >
                Will Attend
              </div>
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6">
            {window.zola.env !== 'production' ? (
              <div
                className={`btn ${isDeclined ? ' btn-active' : ''}`}
                onClick={() => onChange('DECLINED')}
              >
                Will Not<br className="mobile-only" /> Attend
              </div>
            ) : (
              <div
                className={`btn ${isDeclined ? ' btn-active' : ''}`}
                onClick={() => onChange('DECLINED')}
              >
              Will Not Attend
            </div>
            )}
          </div>
        </div>
        {((touched && error) || (stepError && error && window.zola.env !== 'production')) && (
          <span className="help-block danger-text">
            {error}
          </span>
        )}
      </div>
    );
  }
}

AttendingInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  eventInvitationIndex: PropTypes.number, // eslint-disable-line
  stepError: PropTypes.bool
};

const mapDispatchToProps = dispatch => ({
  onRegisterField: (name, type) => dispatch(registerField('GuestRsvpForm', name, type)),
  onChangeField: (name, value) => dispatch(change('GuestRsvpForm', name, value))
});

export default connect(
  null,
  mapDispatchToProps
)(AttendingInput);



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvpV2/RsvpForm/GuestFields/AttendingInput.jsx
 **/